import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // Asset loading lands here in phase 5. For now, no assets — placeholder
    // shapes are rendered via Phaser.GameObjects.Graphics, not loaded files.
  }

  create(): void {
    this.scene.start('TitleScene');
  }
}
